import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { apiInstance } from "./axiosApi";
import authHeader from "./authHeader";

export const getQuestionData = createAsyncThunk("topic/question", async ({ page, limit, classesFilter, subjectId, subTopicId, queType, selectedValue, search }, { rejectWithValue }) => {
  try {
    let url = `/question/all?page=${page}&limit=${limit}&classesFilter=${classesFilter}&subjectFilter=${subjectId}`;

    if (subTopicId !== undefined && subTopicId !== null) {
      url += `&subtopicFilter=${subTopicId}`;
    }

    if (queType && queType.length > 0) {
      const queTypeFilter = queType.join(",");
      url += `&questionTypeFilter=${queTypeFilter}`;
    }

    if (selectedValue) {
      url += `&typeFilter=${selectedValue}`;
    }
    if (search) {
      url += `&search=${search}`;
    }

    const response = await apiInstance.get(url, { headers: authHeader() });
    return response;
  } catch (error) {
    return rejectWithValue(error?.response?.data?.message);
  }
});

export const addQuestion = createAsyncThunk("question/add", async (payload, { rejectWithValue }) => {
  try {
    const response = await apiInstance.post("/question/add", payload, {
      headers: authHeader(),
    });
    return response;
  } catch (error) {
    return rejectWithValue(error?.response?.data?.message);
  }
});

export const editQuestion = createAsyncThunk("question/edit", async (payload, { rejectWithValue }) => {
  try {
    const response = await apiInstance.post("/question/edit", payload, {
      headers: authHeader(),
    });
    return response;
  } catch (error) {
    return rejectWithValue(error?.response?.data?.messagelk);
  }
});

export const questionDelete = createAsyncThunk("question/delete", async (questionId, { rejectWithValue }) => {
  try {
    const response = await apiInstance.delete(`/question/delete/${questionId}`, {
      headers: authHeader(),
    });
    return response;
  } catch (error) {
    return rejectWithValue(error?.response?.data?.message);
  }
});

export const getQuestionById = createAsyncThunk("question/getById", async (id, { rejectWithValue }) => {
  try {
    const response = await apiInstance.get(`/question/${id}`, {
      headers: authHeader(),
    });
    return response;
  } catch (error) {
    return rejectWithValue(error?.response?.data?.message);
  }
});

export const uploadQApdf = createAsyncThunk("question/upload-doc", async (payload, { rejectWithValue }) => {
  try {
    const response = await apiInstance.post(`/question/upload-doc`, payload, {
      headers: {
        ...authHeader(),
        "Content-Type": "multipart/form-data", // ✅ important
      },
    });
    return response;
  } catch (error) {
    return rejectWithValue(error?.response?.data?.message);
  }
});

const initialState = {
  questionData: [],
  getQuestionData: [],
};

const questionSlice = createSlice({
  name: "questionSlice",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(getQuestionData.fulfilled, (state, action) => {
      state.questionData = action.payload.data;
    });
    builder.addCase(getQuestionById.fulfilled, (state, action) => {
      state.getQuestionData = action.payload.data;
    });
  },
});
export default questionSlice.reducer;
